export default {
  SET_TASKS(state, tasks) {
    state.tasks = tasks;
  },
  SET_STATS_LEADS(state, stats) {
    state.stats_leads = stats;
  },
  SET_STATS_OPPORTUNITIES(state, stats) {
    state.stats_opportunities = stats;
  },
  SET_STATS_SALES(state, stats) {
    state.stats_sales = stats;
  },
  SET_INVITATIONS(state, invitations) {
    state.invitations = invitations;
  },
  SET_MEMBERS(state, members) {
    state.members = members;
  },
  SET_CURRENT_TEAM(state, team) {
    state.current_team = team;
  },
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription;
  },
};
